<template>
  <div>
    <main role="main">
      <div  class="container">   
        <section id="about" class="fond">
          <h1 data-aos="fade-right" data-aos-delay="200">{{ $t("home.nav.how-it-work") }}</h1>
          <div class="content" data-aos="fade-left" data-aos-delay="400">
            <p v-html="$t('about.content.1st')"></p>
            <p v-html="$t('about.content.2nd')"></p>
            <p v-html="$t('about.content.3rd')"></p>
            <p v-html="$t('about.content.4th')"></p>

            <div class="team" data-aos="zoom-in" data-aos-delay="200">
                <div class="title" v-html="$t('about.team.title')"></div>
                <ul>
                  <li data-aos="fade-right" data-aos-delay="300">
                    <a target="_blank" href="https://www.linkedin.com/in/matthieugudefin/">
                      <img src="../../assets/matthieu.png" alt="Matthieu">
                      <div class="description">
                        <div class="name">Matthieu</div>
                        <div class="function" v-html="$t('about.team.matthieu.function')"></div>
                        <div class="bio" v-html="$t('about.team.matthieu.bio')"></div>
                      </div>
                    </a>
                  </li>
                  <li data-aos="fade-left" data-aos-delay="400">
                    <img src="../../assets/joseph.png" alt="Joseph">
                    <div class="description">
                      <div class="name">Joseph</div>
                      <div class="function" v-html="$t('about.team.joseph.function')"></div>
                      <div class="bio" v-html="$t('about.team.joseph.bio')"></div>
                    </div>
                  </li>
                  <li data-aos="fade-right" data-aos-delay="500">
                    <img src="../../assets/julien.png" alt="Julien">
                    <div class="description">
                      <div class="name">Julien</div>
                      <div class="function" v-html="$t('about.team.julien.function')"></div>
                      <div class="bio" v-html="$t('about.team.julien.bio')"></div>
                    </div>
                  </li>
                  <li data-aos="fade-left" data-aos-delay="600">
                    <img src="../../assets/aiminne.png" alt="Aïminne">
                    <div class="description">
                      <div class="name">Aïminne</div>
                      <div class="function" v-html="$t('about.team.aiminne.function')"></div>
                      <div class="bio" v-html="$t('about.team.aiminne.bio')"></div>
                    </div>
                  </li>
                </ul>
            </div>
          </div>
        </section>    
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
  .team .title {
    font-size: 30px;
    text-align: center;
    margin: 50px 0;
    padding-top: 35px;
    border-top: 1px solid;
    font-weight: bold;
  }
  .team ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .team li {
    width: 100%;
    text-align: center;
    margin-bottom: 50px;
    max-width: 400px;
  }
  .team li .name {
    width: 150px;
    margin: auto;
    background: #25569f;
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    padding: 5px 0;
  }
  .team li .function {
    font-size: 20px;
    margin: 10px 0;
    font-weight: 600;
  }
  @media (min-width: 768px){
    .team li {
      width: 50%;
    }
  }
</style>
